<div class="container header-title">
  <div class="container">
    <h1>Staff Details</h1>
  </div>
</div>

<div class="container" *ngIf="viewModel() as viewData">
  <div class="container" *ngIf="viewData.staffDetail as staffDetail">
    <div class="header">
      <div class="back-link">
        <a [routerLink]="['/data-lookup', 'staff']" [state]="state">
          <mat-icon>arrow_back</mat-icon> Back to Staff List
        </a>
      </div>
      <div class="buttons">
        <app-additional-info
          [additionalInfoFields]="additionalInfoFields"
          contextKey="StaffDetail"
          (fieldSelected)="onFieldSelected($event)">
        </app-additional-info>
        <ng-container *ngIf="!isExporting; else loadingExport">
          <button tdoe-button size="large" (click)="export(staffDetail.id!, viewData.selectedCategories)">Export</button>
        </ng-container>
        <ng-template #loadingExport>
          <div class="progress-bar">
            <div class="progress-text">Exporting...</div>
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </div>
        </ng-template>
      </div>
    </div>

    <div mat-accordion class="mat-accordion">
      <mat-expansion-panel
        *ngFor="let category of viewData.boundCategories; trackBy: trackCategory"
        [expanded]="expandedStates[category.name]">

        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ category.name }}
          </mat-panel-title>
        </mat-expansion-panel-header>

        <ng-container *ngIf="category.isArray; else dataListBlock">

            <div class="sub-section">
              <div class="scrollinator">

                @if (getArrayData(staffDetail, category.dataPath); as arrayData) {

                  @if (arrayData && arrayData.length > 0) {

                    <mat-table [dataSource]="arrayData">
                      <ng-container
                        *ngFor="let col of category.fields"
                        [matColumnDef]="strip(col.key)">
                        
                        <mat-header-cell *matHeaderCellDef>{{ col.name }}</mat-header-cell>
                        <mat-cell *matCellDef="let item">
                          {{ item | nestedProperty: strip(col.key) }}
                        </mat-cell>
                      </ng-container>

                      <mat-header-row
                        *matHeaderRowDef="viewData.tableColumns[category.name]">
                      </mat-header-row>
                      <mat-row
                        *matRowDef="let row; columns: viewData.tableColumns[category.name]">
                      </mat-row>

                      <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="4">
                          No {{ category.name | lowercase }} found
                          for '{{ staffDetail.nameLast }} {{ staffDetail.nameFirst }}'
                        </td>
                      </tr>
                    </mat-table>

                  } @else {

                    <ngx-skeleton-loader appearance="line" count="9"></ngx-skeleton-loader>

                  }

                }

              </div>
            </div>

        </ng-container>

        <ng-template #dataListBlock>
          <div class="sub-section">
            <div class="data-list">
              <div class="field" *ngFor="let field of category.fields">
                <span class="name">{{ field.name }}</span>
                <span class="value">
                  {{ staffDetail | nestedProperty: strip(category.dataPath ? category.dataPath + '.' + field.key : field.key) }}
                </span>
              </div>
            </div>
          </div>
        </ng-template>

      </mat-expansion-panel>
    </div>

    @if (viewData.visibleCategories.currentAssignments) {

      <div class="mat-accordion" mat-accordion>

        @if (assignmentsViewModel$ | async; as vm) {

          <mat-expansion-panel>
            <mat-expansion-panel-header>

                <mat-panel-title>
                  <span>Class Assignments (</span>
                  <span [innerText]="vm.length | number"></span>
                  <span>)</span>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="sub-section">
              <div class="scrollinator">
                <mat-table [dataSource]="vm ?? []">

                  @for (col of viewData.visibleCategories.currentAssignments.fields;track col) {

                      <ng-container [matColumnDef]="strip(col.key)">
                          <mat-header-cell *matHeaderCellDef>{{ col.name }}</mat-header-cell>
                          <mat-cell *matCellDef="let item">
                              {{ (item | nestedProperty: strip(col.key)) ?? '--' }}
                          </mat-cell>
                      </ng-container>

                  }

                  <mat-header-row *matHeaderRowDef="viewData.displayedColumns.currentAssignments"/>
                  <mat-row *matRowDef="let row;columns: viewData.displayedColumns.currentAssignments" />
                  
                  <tr class="mat-row" *matNoDataRow>
                      <td class="mat-cell" [attr.colspan]="viewData.displayedColumns.currentAssignments?.length">No staff data</td>
                  </tr>
                </mat-table>
              </div>
            </div>

          </mat-expansion-panel>

        } @else {

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span>Current Assignments (Loading...)</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="sub-section">
              <ngx-skeleton-loader appearance="line" count="10"></ngx-skeleton-loader>
            </div>
          </mat-expansion-panel>

        }

      </div>

    }
    
    @if (viewData.visibleCategories.classAssignments) {

      <div class="mat-accordion" mat-accordion>

        @if (classesViewModel$ | async; as classAssignmentsVM) {

          <mat-expansion-panel>
                <mat-expansion-panel-header>

                    <mat-panel-title>
                      <span>Class Assignments (</span>
                      <span [innerText]="classAssignmentsVM.totalRecords | number"></span>
                      <span>)</span>
                    </mat-panel-title>

                </mat-expansion-panel-header>
                <div class="sub-section">
                    <div class="scrollinator">

                      <mat-table [dataSource]="classAssignmentsVM.data ?? []">

                          @for (col of viewData.visibleCategories.classAssignments.fields;track col) {

                              <ng-container [matColumnDef]="strip(col.key)">
                                  <mat-header-cell *matHeaderCellDef>{{ col.name }}</mat-header-cell>
                                  <mat-cell *matCellDef="let item">
                                      {{ (item | nestedProperty: strip(col.key)) ?? '--' }}
                                  </mat-cell>
                              </ng-container>

                          }

                          <mat-header-row *matHeaderRowDef="viewData.displayedColumns.classAssignments"/>
                          <mat-row *matRowDef="let row;columns: viewData.displayedColumns.classAssignments" />
                          
                          <tr class="mat-row" *matNoDataRow>
                              <td class="mat-cell" [attr.colspan]="viewData.displayedColumns.classAssignments?.length">No staff data</td>
                          </tr>
                      </mat-table>

                  </div>

                  <mat-paginator
                      [length]="classAssignmentsVM.totalRecords"
                      [pageSize]="classAssignmentsVM.pageSize"
                      [pageSizeOptions]="[25, 50, 100, 500, 1000]"
                      [pageIndex]="classAssignmentsVM.pageIndex"
                      showFirstLastButtons
                      (page)="pageClasses($event)"/>
                </div>
          </mat-expansion-panel>

        } @else {

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span>Class Assignments (Loading...)</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="sub-section">
              <ngx-skeleton-loader appearance="line" count="10"></ngx-skeleton-loader>
            </div>
          </mat-expansion-panel>

        }

      </div>

    }


  </div>
</div>